export function hasReloaded(): boolean {
    return window.performance
        && performance.navigation.type
        === performance.navigation.TYPE_RELOAD;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/navigation.ts